import React, { useState, useEffect } from "react";
import {
    Container,
    Grid,
    Button,
    Typography,
    Box,
    Autocomplete,
    TextField,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    FormControl,
    Select,
    MenuItem,
} from "@mui/material";

import axios from "axios"
import BaseURL from "../../api/AppURL";
import { useOutletContext } from "react-router-dom"

// Table columns
const columns = [
    "Employee",
    "Opening",
    "Debit",
    "Credit",
    "Debit",
    "Credit",
];

const TeamWisePaymentReport = () => {
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [tableRows, setTableRows] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);

    const [customers, setCustomers] = useState([])
    const [products, setProducts] = useState([])

    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(false);

    // DataTable features


    const [searchTerm, setSearchTerm] = useState("");
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    const [downloading, setDownloading] = useState(false);

    const { showSnackbar } = useOutletContext()
    // Fetch customers and products from API
    const fetchData = async () => {
        setLoadingCustomers(true)
        setLoadingProducts(true)
        try {
            const token = localStorage.getItem("auth_token")
            const response = await axios.get(`${BaseURL}/payment/report`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            })
            setCustomers(response.data.teams || [])
        } catch (err) {
            console.error("Error fetching data:", err)
        } finally {
            setLoadingCustomers(false)
            setLoadingProducts(false)
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    // Table search/filter
    const filteredRows = tableRows.filter((row) => {
        const query = searchTerm.toLowerCase();

        return (
            (row.employee && row.employee.toLowerCase().includes(query)) ||
            (typeof row.employee === 'string'
                ? row.employee.toLowerCase().includes(query)
                : String(row.employee || '').toLowerCase().includes(query)) ||
            row.employee?.toLowerCase().includes(query) ||
            String(row.employee).includes(query)
        );
    });

    // Pagination logic
    const totalEntries = filteredRows.length;
    const totalPages = Math.ceil(totalEntries / entriesPerPage);
    const indexOfLastRow = currentPage * entriesPerPage;
    const indexOfFirstRow = indexOfLastRow - entriesPerPage;
    const displayedRows = filteredRows.slice(indexOfFirstRow, indexOfLastRow);

    const startEntry = totalEntries === 0 ? 0 : indexOfFirstRow + 1;
    const endEntry = Math.min(indexOfLastRow, totalEntries);

    // কোনটা ভালো?
    // GET → যখন ডাটা শুধু ফিল্টার/সার্চ করার জন্য, এবং sensitive কিছু নয়। (বেশিরভাগ রিপোর্ট/সার্চ API GET হয়)
    // POST → যখন payload বড়, অথবা ডাটা body আকারে পাঠানো বেশি যুক্তিযুক্ত (যেমন অনেকগুলো আইডি, বা জটিল সার্চ)।
    // আপনার ক্ষেত্রে যেহেতু তারিখ, কাস্টমার আইডি, প্রোডাক্ট আইডি পাঠানো হচ্ছে (শুধু ফিল্টার),
    // 👉 আমি বলব GET ব্যবহার করাই ভালো।



    const handleSearch = async (e) => {
        e.preventDefault();
        if (!selectedCustomer || !fromDate || !toDate) {
            alert("Customer, From date, To date দিন");
            return;
        }
        setTableLoading(true);
        try {

            const token = localStorage.getItem("auth_token")
            const res = await axios.get(`${BaseURL}/payment/report/show`, {

                params: {
                    date_from: fromDate,
                    date_to: toDate,
                    team_id: selectedCustomer.id,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                },
            });
            // রেসপন্স প্রসেস
            // handleSearch এর মধ্যে, res.data.sale_payments_records থেকে প্রসেস করুন:
            const records = res.data.sale_payments_records || [];
            const rows = records.map(record => {
                // Opening Balance
                const openingBalance = record.total_previous_dew < 0
                    ? `${Math.abs(record.total_previous_dew)} cr`
                    : `${record.total_previous_dew} dr`;

                // Transaction Debit & Credit
                const transactionDebit = (record.sales || []).reduce(
                    (sum, sale) => sum + parseFloat(sale.total_sale_amount || 0), 0
                );
                const transactionCredit = (record.payments || []).reduce(
                    (sum, payment) => sum + parseFloat(payment.total_payment_amount || 0), 0
                );

                // Closing amounts
                const closingAmount = Number(record.total_previous_dew) + transactionDebit - transactionCredit;
                const closingDebit = closingAmount >= 0 ? closingAmount : '';
                const closingCredit = closingAmount < 0 ? `${Math.abs(closingAmount)}` : '';

                return {
                    employee: record.name,
                    opening: openingBalance,
                    transaction_debit: transactionDebit,
                    transaction_credit: transactionCredit,
                    closing_debit: closingDebit,
                    closing_credit: closingCredit,
                };
            });
            setTableRows(rows);
        } catch (err) {
            setTableRows([]);
            alert("ডাটা লোড করতে সমস্যা হচ্ছে");
        }
        setTableLoading(false);
    };




    const handleEntriesChange = (event) => {
        setEntriesPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleTableSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

    const handlePreviewReport = async () => {
        if (!selectedCustomer || !fromDate || !toDate) {
            alert("Customer, From date, To date দিন");
            return;
        }
        setDownloading(true);
        try {
            const token = localStorage.getItem("auth_token");
            const params = {
                from_date: fromDate,
                to_date: toDate,
                customer_id: selectedCustomer.id,
                product_id: selectedProduct ? selectedProduct.id : ""
            };
            const queryString = new URLSearchParams(params).toString();
            const pdfUrl = `${BaseURL}/salesrangespecific/apireport/download?${queryString}`;

            // নতুন ট্যাবে স্ট্রিম করুন
            window.open(pdfUrl, "_blank");
            showSnackbar("PDF streaming in browser!", "success");
        } catch (err) {
            console.error("Error streaming PDF:", err);
            showSnackbar("Failed to stream PDF report. Please try again.", "error");
        } finally {
            setDownloading(false);
        }
    };


    const handleDownloadReport = async () => {
        if (!selectedCustomer || !fromDate || !toDate) {
            alert("Customer, From date, To date দিন");
            return;
        }
        setDownloading(true);
        try {
            const token = localStorage.getItem("auth_token");
            const params = {
                date_from: fromDate,
                date_to: toDate,
                team_id: selectedCustomer.id,
            };

            const response = await axios.get(
                `${BaseURL}/paymentapi/report/download`,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/pdf"
                    },
                    responseType: "blob",
                }
            );
            const contentDisposition = response.headers["content-disposition"]
            console.log("Content-Disposition Header:", contentDisposition)
            let filename = "suppliers_report.pdf"
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/)
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1]
                } else {
                    const unquotedFilenameMatch = contentDisposition.match(/filename=([^;]+)/)
                    if (unquotedFilenameMatch && unquotedFilenameMatch[1]) {
                        filename = unquotedFilenameMatch[1].trim()
                    }
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", filename)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
            window.URL.revokeObjectURL(url)
            showSnackbar("PDF report downloaded successfully!", "success")
        } catch (err) {
            console.error("Error downloading PDF:", err)
            showSnackbar("Failed to download PDF report. Please try again.", "error")
        } finally {
            setDownloading(false)
        }
    }

    // Row background color logic for alternate rows
    const getRowStyle = (idx) =>
        idx % 2 === 0
            ? { backgroundColor: "#f9f9f9" } // off-white
            : { backgroundColor: "#fff" };   // default white

    return (
        <Box sx={{ background: "#fff", minHeight: "100vh", py: 4 }}>
            <Container maxWidth="lg">
                <Typography variant="h5" fontWeight="bold" color="primary" mb={2}>
                    Payments Report Search
                </Typography>
                {/* Main Form: untouched */}
                <Box component="form" onSubmit={handleSearch} mb={4}>
                    <Grid container spacing={2} alignItems="center">
                        {/* Customer Dropdown */}
                        <Grid item xs={12} sm={6} md={3} >
                            <Box sx={{ minWidth: 250, maxWidth: 400, width: "100%" }}>
                                <Autocomplete
                                    options={customers}
                                    getOptionLabel={(option) =>
                                        `${option.name}${option.mobile_no ? " " + option.mobile_no : ""}`
                                    }
                                    value={selectedCustomer}
                                    onChange={(e, v) => setSelectedCustomer(v)}
                                    loading={loadingCustomers}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Team" variant="outlined" fullWidth

                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    height: "44px",
                                                    paddingTop: "0px",
                                                    paddingBottom: "0px",
                                                    '@media (min-width: 1200px) and (max-width: 1344px)': {
                                                        width: "200px"
                                                    },
                                                    // টেক্সট ওভারফ্লো সলিউশন
                                                    "& .MuiAutocomplete-input": {
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "clip"
                                                    }
                                                },
                                                "& .MuiInputLabel-outlined": {
                                                    transform: "translate(14px, 14px) scale(1)",
                                                },
                                                "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                                                    transform: "translate(14px, -6px) scale(0.75)",
                                                },
                                            }}

                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {loadingCustomers ? (
                                                            <CircularProgress color="inherit" size={20} />
                                                        ) : null}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}

                                        />
                                    )}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}

                                />
                            </Box>
                        </Grid>


                        {/* From Date */}
                        <Grid item xs={12} sm={6} md={2} sx={{
                            '@media (min-width: 1200px) and (max-width: 1344px)': {
                                paddingLeft: '0px !important',
                                marginLeft: { xs: '0px', sm: '-15px', md: '-50px' }
                            } // রেস্পন্সিভ নেগেটিভ মার্জিন
                        }}>
                            <TextField
                                label="From Date"
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                fullWidth
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '44px'
                                    },
                                    '& .MuiInputLabel-root': {
                                        transform: 'translate(14px, -6px) scale(0.75)'
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        transform: 'translate(14px, -6px) scale(0.75)'
                                    }
                                }}
                            />
                        </Grid>
                        {/* To Date */}
                        <Grid item xs={12} sm={6} md={2}
                            sx={{
                                '@media (min-width: 1200px) and (max-width: 1236px)': {
                                    paddingLeft: '0px !important',
                                    marginLeft: { xs: '0px', sm: '-12px', md: '-10px' }
                                } // রেস্পন্সিভ নেগেটিভ মার্জিন
                            }}
                        >
                            <TextField
                                label="To Date"
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant="outlined"
                                fullWidth
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: '44px'
                                    },
                                    '& .MuiInputLabel-root': {
                                        transform: 'translate(14px, -6px) scale(0.75)'
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        transform: 'translate(14px, -6px) scale(0.75)'
                                    }
                                }}
                            />
                        </Grid>
                        {/* Search Button */}
                        <Grid item xs={12} sm={6} md={2}
                            sx={{
                                '@media (min-width: 1200px) and (max-width: 1236px)': {
                                    paddingLeft: '0px !important',
                                    marginLeft: { xs: '0px', sm: '-15px', md: '-30px' }
                                } // রেস্পন্সিভ নেগেটিভ মার্জিন
                            }}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="info"
                                fullWidth
                                sx={{
                                    //   height: "56px",
                                    height: "44px",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    boxShadow: 1,
                                    "&:hover": { background: "#1976d2", color: "#fff" },
                                }}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                {/* DataTable controls: Download Report TOP RIGHT */}
                {tableRows.length > 0 && (
                    <Box
                        sx={{
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 2,
                        }}
                    >
                        {/* Left side: Show Entries + Search */}
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                            {/* Show Entries Dropdown */}
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography variant="body2">Show</Typography>
                                <FormControl size="small" sx={{ minWidth: 80 }}>
                                    <Select
                                        value={entriesPerPage}
                                        onChange={handleEntriesChange}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                        <MenuItem value={100}>100</MenuItem>
                                    </Select>
                                </FormControl>
                                <Typography variant="body2">entries</Typography>
                            </Box>
                            {/* Search Input for Table */}
                            <TextField
                                label="Search"
                                variant="outlined"
                                size="small"
                                value={searchTerm}
                                onChange={handleTableSearch}
                                sx={{ width: { xs: "100%", sm: "250px" } }}
                            />
                        </Box>
                        {/* Right side: Download Report */}
                        {filteredRows.length > 0 && (
                            <Button
                                variant="outlined"
                                color="success"
                                onClick={handleDownloadReport}
                                disabled={downloading}
                                sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
                            >
                                {downloading ? "Downloading..." : "Download Report"}
                            </Button>
                        )}
                    </Box>
                )}

                {/* Table */}
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" rowSpan={2} sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Employee
                                </TableCell>
                                <TableCell align="center" rowSpan={2} sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Opening
                                </TableCell>
                                <TableCell align="center" colSpan={2} sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Transaction
                                </TableCell>
                                <TableCell align="center" colSpan={2} sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5"
                                }}>
                                    Closing
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="center" sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Debit
                                </TableCell>
                                <TableCell align="center" sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Credit
                                </TableCell>
                                <TableCell align="center" sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5", borderRight: "1px solid #e0e0e0"
                                }}>
                                    Debit
                                </TableCell>
                                <TableCell align="center" sx={{
                                    fontWeight: "bold", whiteSpace: "nowrap", fontSize: "1.05rem", background: "#f5f5f5"
                                }}>
                                    Credit
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableLoading ? (
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center">
                                        Loading...
                                    </TableCell>
                                </TableRow>
                            ) : displayedRows.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={columns.length} align="center" sx={{ color: "red" }}>
                                        No record found
                                    </TableCell>
                                </TableRow>
                            ) : (
                                displayedRows.map((row, idx) => (
                                    <TableRow
                                        key={idx}
                                        sx={{
                                            ...getRowStyle(idx),
                                            borderBottom: "1px solid #e0e0e0", // horizontal line between rows
                                        }}
                                    >
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.employee}</TableCell>
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.opening}</TableCell>
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.transaction_debit}</TableCell>
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.transaction_credit}</TableCell>
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.closing_debit}</TableCell>
                                        <TableCell align="center" sx={{ borderRight: "1px solid #e0e0e0" }}>{row.closing_credit}</TableCell>
                                        <TableCell align="center">{row.total_price}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* Pagination */}
                {tableRows.length > 0 && filteredRows.length > 0 && (
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            justifyContent: "space-between",
                            alignItems: { xs: "center", sm: "center" },
                            gap: 2,
                            mt: 2,
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            Showing {startEntry} to {endEntry} of {totalEntries} entries
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button variant="outlined" onClick={handlePrevPage} disabled={currentPage === 1}>
                                Prev
                            </Button>
                            {Array.from({ length: totalPages }, (_, i) => (
                                <Button
                                    key={i + 1}
                                    variant={currentPage === i + 1 ? "contained" : "outlined"}
                                    color={currentPage === i + 1 ? "primary" : "inherit"}
                                    onClick={() => setCurrentPage(i + 1)}
                                    sx={{ minWidth: 40, px: 1 }}
                                >
                                    {i + 1}
                                </Button>
                            ))}
                            <Button variant="outlined" onClick={handleNextPage} disabled={currentPage === totalPages || totalPages === 0}>
                                Next
                            </Button>
                        </Box>
                    </Box>
                )}
            </Container>
        </Box>
    );
};

export default TeamWisePaymentReport;